<template>
	<div class="component">
		<ul class="progressbar">
			<li v-bind:class="getStepStyle('agentQuestions')">Your Agent
				<div class="bar">
					<div v-bind:class="getProgressStyle('agentQuestions')"></div>
				</div>
			</li>
			<li v-bind:class="getStepStyle('customerQuestions')">About You
				<div class="bar">
					<div v-bind:class="getProgressStyle('customerQuestions')"></div>
				</div>
			</li>
			<li v-bind:class="getStepStyleFromRange('propertyQuestions', 'occupantQuestions')">Your Property
				<div class="bar">
					<div v-bind:class="propertyProgressStyle"></div>
				</div>
			</li>
			<li v-if="this.type === 'cash'" v-bind:class="thankYouStepStyle">Finished</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'ProgressBar',
	props: ['value', 'type', 'steps'],
		data (){
			return {
				stepNames: undefined,
				stepNameStartIndex: undefined,
				stepNameEndIndex: undefined,
				currentStepIndex: undefined
			}
		},
	methods: { 
		popStepValues(stepNameStart, stepNameEnd) {
			const stepNames = this.steps.map(x => x.name);
			if (stepNameEnd) {
				this.stepNameStartIndex = stepNames.indexOf(stepNameStart);
				this.stepNameEndIndex = stepNames.indexOf(stepNameEnd);				
			} else {
				this.stepNameIndex = stepNames.indexOf(stepNameStart);
			}			
			this.currentStepIndex = stepNames.indexOf(this.value);
		},
		getStepStyleFromRange(stepNameStart, stepNameEnd) {
				this.popStepValues(stepNameStart, stepNameEnd)
				if (this.stepNameStartIndex <= this.currentStepIndex > this.stepNameEndIndex) {
					return 'active'
				} else if (this.currentStepIndex > this.stepNameEndIndex) {
					return 'done';
				} else {
					return ''
				}    
			},
		getStepStyle(stepName) {
				this.popStepValues(stepName)
				if (this.currentStepIndex === this.stepNameIndex) {
					return 'active';
				} else if (this.currentStepIndex < this.stepNameIndex) {
					return '';
				} else {
					return 'done'
				}                
			},
		getProgressStyle(stepName) {
				this.popStepValues(stepName)
				if (this.currentStepIndex === this.stepNameIndex) {
					return 'active-bar active-bar-width-20';
				} else if (this.currentStepIndex < this.stepNameIndex) {
					return '';
				} else {
					return 'full-bar'
				}
			},
			singleQuestionProgress(stepName) {
				return this.getStepStyle(stepName, 'full-bar', 'active-bar active-bar-width-20');
			}
		},
		computed: {
			propertyProgressStyle() {
					switch (this.value) {
							case 'propertyQuestions':
									return 'active-bar active-bar-width-20';
							case 'propertyOutdoorQuestions':
									return 'active-bar active-bar-width-40';
							case 'neighborhoodQuestions':
									return 'active-bar active-bar-width-60';
							case 'occupantQuestions':
									return 'active-bar active-bar-width-80';
							case 'uploadAssets':
									return 'active-bar active-bar-width-90';
							case 'thankYou':
									return 'full-bar';
							default:
									return 'active-bar active-bar-width-1';
					}
			},
			thankYouStepStyle() {
					return this.value === 'thankYou' ? 'done' : ''
			}
		}
	}
</script>

<style scoped>
	.progressbar {
		counter-reset: step;
	}

	ul {
		padding: 0;
	}

	.progressbar li {
		list-style-type: none;
		float: left;
		width: 25%;
		position: relative;
		text-align: center;
	}

	.progressbar li::before {
		counter-increment: step;
		content: counter(step);
		width: 45px;
		height: 45px;
		line-height: 40px;
		border: 3px solid #ddd;
		display: block;
		text-align: center;
		margin: 0 auto 10px auto;
		border-radius: 50%;
		background-color: white;
		font-weight: bold;
	}

	.bar {
		min-height: 4px;
		background-color: #ddd;
		width: 100%;
		position: absolute;
		top: 20px;
		left: +50%;
		z-index: -1;
	}

	.active-bar {
		min-height: 4px;
		background-color: #003366;
		width: 1%;
		transition: width 1s;
	}

	.active-bar-width-1 {
		width: 1%;
		transition: width 1s;
	}

	.active-bar-width-20 {
		width: 20%;
		transition: width 1s;
	}

	.active-bar-width-40 {
		width: 40%;
		transition: width 1s;
	}

	.active-bar-width-60 {
		width: 60%;
		transition: width 1s;
	}

	.active-bar-width-80 {
		width: 80%;
		transition: width 1s;
	}

	.active-bar-width-90 {
		width: 90%;
		transition: width 1s;
	}
	.active-bar-width-100 {
		width: 100%;
		transition: width 1s;
	}

	.progressbar li:first-child::after {
		content: none;
	}

	.progressbar li.active::before {
		color: #fff;
		border-color: #003366;
		background-color: #00b4ef;
		transition-delay: .75s;
	}

	.progressbar li.done::before {
		content: '';
		border-color: #003366;
		background-color: #b3efb3;
		background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='%23008000' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M13.854 3.646a.5.5 0 010 .708l-7 7a.5.5 0 01-.708 0l-3.5-3.5a.5.5 0 11.708-.708L6.5 10.293l6.646-6.647a.5.5 0 01.708 0z'/></svg>");
		background-repeat: no-repeat;
		background-position: bottom;
		background-size: 2rem 2rem;
	}

	.full-bar {
		width:100%;
		min-height: 4px;
		background-color: #003366;
	}
	.zero-bar {
		width:0%;
	}

</style>
